import React, { Component } from "react";
import RaisedButton from "material-ui/RaisedButton";
import { TextField, SelectField, MenuItem } from "material-ui";

import "./Image.css";

export default class Image extends Component {
  state = {
    label: "",
    altText: "",
    facet: 0
  };

  componentDidMount() {
    const { label, altText, facet } = this.props;
    this.setState({
      label: label && label.length > 0 ? label : "",
      altText: altText && altText.length > 0 ? altText : "",
      facet: facet !== undefined ? facet : 0,
      windowWidth:
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth
    });
    if (typeof window !== "undefined")
      window.addEventListener("resize", this.onResizeFct, false);
  }

  onResizeFct = () => {
    this.setState({
      windowWidth:
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const { label, altText, facet } = this.props;
    if (label !== prevProps.label || altText !== prevProps.altText)
      this.setState({
        label: label && label.length > 0 ? label : "",
        altText: altText && altText.length > 0 ? altText : "",
        facet: facet !== undefined ? facet : 0
      });
  }

  componentWillUnmount() {
    if (typeof window !== "undefined")
      window.removeEventListener("resize", this.onResizeFct, false);
  }

  handleSubmit = id => e => {
    e.preventDefault();
    this.props.updateCallback(
      id,
      this.state.label,
      this.state.altText,
      this.state.facet
    );
  };

  changeLabel = id => (e, value) => {
    this.setState({ label: value });
  };

  changeAltText = id => (e, value) => {
    this.setState({ altText: value });
  };

  changeFacet = id => (e, value) => {
    this.setState({ facet: value });
  };

  render() {
    const { id, img, deleteCallback, updateCallback } = this.props;
    const { label, altText, facet, windowWidth } = this.state;
    return (
      <div className="image-tile">
        <div
          className="image"
          style={{
            backgroundImage: `url("/assets/images/${img}")`
          }}
        />
        <div className="image-infos">
          <form onSubmit={this.handleSubmit(id)}>
            <div className="fieldset">
              <TextField
                floatingLabelText="Titre"
                value={label}
                onChange={this.changeLabel(id)}
              />
              <TextField
                floatingLabelText="Description"
                value={altText}
                onChange={this.changeAltText(id)}
              />
              <SelectField
                floatingLabelText="Aspect"
                value={facet}
                onChange={this.changeFacet(id)}
              >
                <MenuItem value={0} primaryText="Hiver" />
                <MenuItem value={1} primaryText="Été" />
                <MenuItem value={2} primaryText="Toutes saisons" />
              </SelectField>
            </div>
            <div className="fieldset image-action-btn">
              {deleteCallback && typeof deleteCallback === "function" ? (
                <RaisedButton
                  secondary
                  className="delete-image-btn"
                  label={windowWidth > 422 ? "Supprimer l'image" : "Supprimer"}
                  onClick={deleteCallback(id)}
                />
              ) : null}
              {updateCallback && typeof updateCallback === "function" ? (
                <RaisedButton
                  type="submit"
                  secondary
                  className="form-validate-btn"
                  label="Valider"
                />
              ) : null}
            </div>
          </form>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/merchant/accomodation/Image.js